import { Component, HostListener, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LayoutManagerService} from '../layout-manager.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  layoutManager

  @Input('background')background='white'

  tabsNames = ['home', 'store', 'come funziona', 'chi siamo',  'partners', 'affiliate program', 'contattaci']

  currentTab: string

  loaded: boolean

  document = (document.querySelector('.topbar.fixed-header') as HTMLDivElement)

  constructor(
    private router: Router,
    layoutManager: LayoutManagerService
  ) {
    this.layoutManager = layoutManager
  }

  loginClick() {
    this.router.navigateByUrl('/login')
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    this.document = (document.querySelector('.topbar.fixed-header') as HTMLDivElement)
  }


  ngOnInit(): void {
    const url = this.router.url;
    const urlSplited = url.split('/');
    this.currentTab = urlSplited[1]
    this.currentTab = this.currentTab.replace("%20"," ")
    this.loaded = true;
  }

}
